<div class="row page-header">
    <div class="col-12">
        <h1>Retention <small>View information related to employee retention over time.</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Retention Analytics</a>
            <ng-template ngbNavContent>
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <!--<wj-combo-box name="selectedTimeunit" [hidden]="true"
                                          [itemsSource]="timeunits"
                                          (selectedIndexChanged)="refresh()"
                                          [displayMemberPath]="'display'"
                                          [selectedValuePath]="'value'"
                                          [(ngModel)]="selectedTimeunit">
                            </wj-combo-box>-->
                            <wj-combo-box
                                name="selectedStackOption"
                                style="width: 230px"
                                [itemsSource]="stackingOptions"
                                (selectedIndexChanged)="refresh()"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                                [(ngModel)]="selectedStackOption"
                            >
                            </wj-combo-box>
                        </form>
                    </div>
                </div>
                <wj-flex-chart
                    [itemsSource]="masterData"
                    [bindingX]="'formattedDate'"
                    [chartType]="'Line'"
                    appAutoSize
                    [header]="'Employee Retention Over Time'"
                    [legendToggle]="true"
                >
                    <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                    <wj-flex-chart-axis
                        [wjProperty]="'axisY'"
                        [title]="'Retention Percentage'"
                        [min]="0"
                        [max]="1.1"
                        [format]="'P2'"
                    ></wj-flex-chart-axis>
                    <wj-flex-chart-series [binding]="'Retention'" [name]="'All Retention'" [chartType]="'Line'"></wj-flex-chart-series>
                    @for (serieName of otherSeriesNames; track serieName) {
                        <wj-flex-chart-series [binding]="serieName" [name]="serieName" [visibility]="'Legend'"></wj-flex-chart-series>
                    }
                    <wj-flex-chart-annotation-layer control="al">
                        @for (annotation of mitigationGrid.items; track annotation) {
                            <wj-flex-chart-annotation-text
                                [attachment]="'DataIndex'"
                                [text]="annotation.chartLabel"
                                position="Center"
                                [pointIndex]="annotation.pointIndex"
                                [point]="{ x: 20, y: 20 }"
                                tooltip="{{ annotation.description }}"
                                [style]="{ fill: '#bbbbbb', 'font-size': '18px' }"
                            ></wj-flex-chart-annotation-text>
                        }
                    </wj-flex-chart-annotation-layer>
                </wj-flex-chart>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Retention Events</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="mitigationGrid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="mitigationGrid"
                                        [canEdit]="canEdit"
                                        [showAdd]="true"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                    ></action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="mitigationGrid.filter"></action-toolbar-search>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridMitigation"
                                    #gridMitigation
                                    appAutoSize
                                    (initialized)="mitigationGrid.initialize(gridMitigation)"
                                    (destroy)="mitigationGrid.destroy()"
                                    [itemsSource]="mitigationGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Chart Label'"
                                        [binding]="'chartLabel'"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Description'"
                                        [binding]="'description'"
                                        [width]="'3*'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
